import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateInterval',
  standalone: false,
})
export class DateIntervalPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: { from: Date; to: Date }): string {
    const { from, to } = value;

    if (this.isSameDay(from, to)) {
      return `${this.datePipe.transform(from, 'd MMMM HH:mm')}  – ${this.datePipe.transform(to, 'HH:mm')}`;
    }

    return `${this.datePipe.transform(from, 'd MMMM HH:mm')}  – ${this.datePipe.transform(to, 'd MMMM HH:mm')}`;
  }

  private isSameDay(from: Date, to: Date): boolean {
    return (
      from.getDate() === to.getDate() && from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()
    );
  }
}
